import { render, staticRenderFns } from "./RemarkListPopup.vue?vue&type=template&id=6e7684ac&scoped=true&"
import script from "./RemarkListPopup.vue?vue&type=script&lang=js&"
export * from "./RemarkListPopup.vue?vue&type=script&lang=js&"
import style0 from "./RemarkListPopup.vue?vue&type=style&index=0&id=6e7684ac&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7684ac",
  null
  
)

export default component.exports